import { Controller } from "@hotwired/stimulus"

// Replaces the server-rendered schedule (app Time.zone) with the viewer's
// local date, start–end range, and timezone abbreviation.
export default class extends Controller {
  static values = { start: String, end: String }
  static targets = ["date", "time"]

  connect() {
    const start = this.parse(this.startValue)
    if (!start) return

    const end = this.parse(this.endValue)
    if (this.hasDateTarget) this.dateTarget.textContent = this.formatDate(start)
    if (this.hasTimeTarget) this.timeTarget.textContent = this.formatRange(start, end)
  }

  parse(value) {
    if (!value) return null

    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? null : date
  }

  formatDate(date) {
    return new Intl.DateTimeFormat(undefined, {
      month: "long",
      day: "numeric",
      year: "numeric"
    }).format(date)
  }

  formatRange(start, end) {
    const zone = this.zoneName(start)
    if (!end) return `${this.formatTime(start)} ${zone}`

    return `${this.formatTime(start)} – ${this.formatTime(end)} ${zone}`
  }

  formatTime(date) {
    return new Intl.DateTimeFormat(undefined, {
      hour: "numeric",
      minute: "2-digit"
    }).format(date)
  }

  zoneName(date) {
    const parts = new Intl.DateTimeFormat(undefined, { timeZoneName: "short" }).formatToParts(date)
    return parts.find((part) => part.type === "timeZoneName")?.value || ""
  }
}
